import { SPage } from "src/components/spage";

interface IProps {}
export const MyBookingsPage = ({}: IProps) => {
  return <SPage title={"My Bookings"}></SPage>;
};
